import Typography from "@mui/material/Typography";
import { memo } from "react";

import { useTranslate } from "@/hooks";

const Copyright = memo(() => {
  const translate = useTranslate();

  return (
    <Typography variant="body2" color="text.secondary">
      {translate("footer.copyright", { year: new Date().getFullYear() })}
    </Typography>
  );
});
Copyright.displayName = "Copyright";

export default Copyright;
